import { NOT_LISTED_IN_INSURANCE_COMPANY_NAMES_LIST } from '@shared/constants/thirdParty';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
import { GlassBreakageRoomDamagesOrigin } from '@shared/types/api/glassBreakageDamage';
export const thirdPartyConstraints = (typeTrigram, roomDamagesOrigin) => {
    const thirdPartyAddressHasMandatory = insurerHasFeature(InsurerFeatureFlag.ThirdPartyAddressHasMandatory, typeTrigram);
    const insuranceCompanyHasNotMandatory = insurerHasFeature(InsurerFeatureFlag.InsuranceCompanyHasNotMandatory, typeTrigram);
    const shouldSkipInsuranceCompanyValidation = insuranceCompanyHasNotMandatory &&
        roomDamagesOrigin === GlassBreakageRoomDamagesOrigin.Professional;
    return {
        'contact.companyName': {
            presenceIfValue: {
                attribute: 'contact.isCompany',
                triggeringValue: [true],
                allowEmpty: false,
                message: 'claim.third_party.form.validator.contact.companyName',
            },
        },
        'contact.lastName': {
            presenceIfValue: {
                attribute: 'contact.isCompany',
                triggeringValue: [false, undefined],
                allowEmpty: false,
                message: 'claim.third_party.form.validator.contact.lastName',
            },
        },
        'contact.firstName': {
            presenceIfValue: {
                attribute: 'contact.isCompany',
                triggeringValue: [false, undefined],
                allowEmpty: false,
                message: 'claim.third_party.form.validator.contact.firstName',
            },
        },
        ...(thirdPartyAddressHasMandatory && {
            'contact.address': {
                presence: {
                    allowEmpty: false,
                    message: 'claim.third_party.form.validator.contact.address',
                },
            },
            'contact.zipcode': {
                presence: {
                    allowEmpty: false,
                    message: 'claim.third_party.form.validator.contact.zipcode',
                },
            },
            'contact.city': {
                presence: {
                    allowEmpty: false,
                    message: 'claim.third_party.form.validator.contact.city',
                },
            },
        }),
        ...(!shouldSkipInsuranceCompanyValidation && {
            'insuranceCompany.name': {
                presence: {
                    allowEmpty: false,
                    message: 'claim.third_party.form.validator.insuranceCompany.name',
                },
            },
        }),
        ...(!shouldSkipInsuranceCompanyValidation && {
            'insuranceCompany.handWrittenName': {
                presenceIfValue: {
                    attribute: 'insuranceCompany.name',
                    triggeringValue: [NOT_LISTED_IN_INSURANCE_COMPANY_NAMES_LIST.notInList],
                    allowEmpty: false,
                    message: 'claim.third_party.form.validator.insuranceCompany.handWrittenName',
                },
            },
        }),
    };
};
